import React, { Component } from 'react';
import logo from './logo.svg';
import './App.css';

//COMPONENTS
import QRefTrans from './components/q_ref_trans';
import QDeclara from './components/q_declara';
import QImmut from './components/q_immut';
import QArgs from './components/q_args';
import QCompose from './components/q_compose';
import QRtErr from './components/q_rt_err';
import QProof from './components/q_proof';

class App extends Component {
  render() {
    return (
      <div className="App">
        <header className="App-header">
          <img src={logo} className="App-logo" alt="logo" />
          <h1 className="App-title">Functional Programming Teaser</h1>
        </header>
        <p className="App-intro">
          Declarative, pure and referentially transparent.
        </p>
        <hr/>
        <div>
          <QRefTrans />
        </div>
        <div>
          <QDeclara />
        </div>
        <div>
          <QImmut />
        </div>
        <div>
          <QArgs />
        </div>
        <div>
          <QCompose />
        </div>
        <div>
          <QRtErr />
        </div>
        <div>
          <QProof />
        </div>
      </div>
    );
  }
}

export default App;



// WEBPACK FOOTER //
// ./src/App.js